import React from 'react';
import { DOMAIN_LIST } from '../constants/domainConfig';

export default function DomainSelector({ activeDomain, onDomainChange }) {
  return (
    <div className="domain-selector">
      {DOMAIN_LIST.map((d) => (
        <button
          key={d.key}
          type="button"
          onClick={() => onDomainChange(d.key)}
          className={`domain-selector-btn${activeDomain === d.key ? ' domain-selector-btn-active' : ''}`}
        >
          {d.label}
        </button>
      ))}
    </div>
  );
}
